import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidSilkPrintMethod from "../../../../service/visibleValidator/isValidSilkPrintMethod"

import お任せ from "./entrust.png"
import 写真法 from "./photolithography.png"

const シルク印刷工法 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { silkPrintMethod: shouldShow } = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      disabled={disabled.silkPrintMethod}
      legend="シルク印刷工法"
      helpURL={HELP_LINKS.シルク印刷工法}
    >
      <RadioGroup
        name={FIELD_NAMES.シルク印刷工法}
        selectedValue={values.silkPrintMethod}
        onChange={handlers.radio}
        disabled={disabled.silkPrintMethod}
        shouldRender={(value) => isValidSilkPrintMethod(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.シルク印刷工法.お任せ.value} prefixImageSrc={お任せ}>
            お任せ
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.シルク印刷工法.写真法.value} prefixImageSrc={写真法}>
            写真法
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.silkPrintMethod} />
    </OneClickField>
  )
}

export default シルク印刷工法
